import { generateBFFUrl } from '@/configs/apiEndPoints';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ERROR } from '@/configs/constants';
import { ECOM_ORDER_CONFIRMATION, ECOM_ORDER_DETAILS, ECOM_ORDER_LIST } from '@/configs/ecom/apis';
import axiosInstance from '../axiosConfig';
import generateHttpHeaders from '../axiosConfig/generateHttpHeaders';

export const getOrderConfirmationStatus = async (
  orderId: string,
  paymentIdHex: string,
  status: string,
  body: any,
  serverCookie?: string,
): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(ECOM_ORDER_CONFIRMATION + orderId), body, {
      params: {
        status,
        paymentIdHex,
      },
      headers: generateHttpHeaders(serverCookie),
    });
  } catch (error: any) {
    console.log(error?.message);
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const getOrderList = async (body: any): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(ECOM_ORDER_LIST), body);
  } catch (error: any) {
    console.log(error?.message);
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const getOrderDetails = async (orderItemId: string, group = false): Promise<any> => {
  try {
    return await axiosInstance.get(generateBFFUrl(ECOM_ORDER_DETAILS + orderItemId), {
      params: {
        group,
      },
    });
  } catch (error: any) {
    console.log(error?.message);
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};
